export default function createAriaRef() {
	// noop since we've removed the rest of the implementation
	return {};
}
